import { useEffect, useState } from "react";
import { fetchProjectResourceMappings, downloadMappingsExcel } from "../Api/ViewProjectResourceMapping";
import { Container, Table, Button } from "react-bootstrap";

import { toast } from "react-toastify";
import moment from "moment";

const ViewProjectResourceMapping = () => {
  const [mappings, setMappings] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const loadMappings = async () => {
      try {
        const data = await fetchProjectResourceMappings();
        setMappings(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Project Resource Mappings`);
      }
    };

    loadMappings();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadMappingsExcel();
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Project_Resource_Mappings.xlsx');
      
      
      document.body.appendChild(link);
      link.click();
      
      
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("Project Resource Mappings download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="list-container">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h2 className="list-title">View Project Resource Mappings</h2>
              <Button className="generate-btn"
                variant="primary" 
                onClick={handleDownload}
                disabled={isDownloading || mappings.length === 0}
              >
                {isDownloading ? 'Downloading...' : 'Download Data'}
              </Button>
            </div>

            {mappings.length > 0 ? (
              <Table bordered hover responsive className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Project Code</th>
                    <th>Project Name</th>
                    <th>Resource</th>
                    <th>Active</th>
                    <th>Per Day Cost</th>
                    <th>Per Day Billable Amount</th>
                    <th>Vendor</th>
                    <th>STPL</th>
                    <th>CA</th>
                    <th>Entered By</th>
                    <th>Created On</th>
                    <th>Created By</th>
                    <th>Changed On</th>
                    <th>Changed By</th>
                  </tr>
                </thead>
                <tbody>
                  {mappings.map((mapping, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{mapping.projectCode}</td>
                      <td>{mapping.projectName}</td>
                      <td>{mapping.resource}</td>
                      <td>{mapping.active === 1 ? 'Yes' : 'No'}</td>
                      <td>{mapping.perDayCost}</td>
                      <td>{mapping.perDayBillableAmount}</td>
                      <td>{mapping.vendor}</td>
                      <td>{mapping.stpL_Yes_No ? 'Yes' : 'No'}</td>
                      <td>{mapping.cA_Yes_No ? 'Yes' : 'No'}</td>
                      <td>{mapping.enteredBy}</td>
                      <td>
                        {mapping.createdOnDate ? moment(mapping.createdOnDate).format('L') : 'N/A'} 
                        {mapping.createdOnTime && ` at ${mapping.createdOnTime.split('.')[0]}`}
                      </td>
                      <td>{mapping.createdBy}</td>
                      <td>
                        {mapping.changedOnDate ? moment(mapping.changedOnDate).format('L') : 'N/A'} 
                        {mapping.changedOnTime && ` at ${mapping.changedOnTime.split('.')[0]}`}
                      </td>
                      <td>{mapping.changedBy}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="no-data">No project resource mappings found.</p>
            )}
          </Container>
        </div>
      
    </>
  );
};

export default ViewProjectResourceMapping;